import React, { useContext } from 'react'
import { AiOutlineCloseCircle, AiOutlineUnlock } from 'react-icons/ai'
import { EditorContext } from '../../../../../../components/CanvasEditor/Context/EditorProvider'

const List = () => {

  const { editor, selectedObjects } = useContext(EditorContext)

  const activeLayers = editor?.getAllObjects() || []

  const handleDelete = (id) => {
    editor.selectedCanvasObjects(id)
    editor.deleteSelected()
  }

  const selectCanvas = (id) => {
    editor.selectedCanvasObjects(id)
  }

  return (
    <div className='layer-list'>
      {
        editor &&
        activeLayers.map((obj, index)=>(
          <div className={`layer`} key={`inddex-layer-${index}`} onClick={e=> selectCanvas(index)}>
            <div className='description'>
              {
                obj.type === 'text' &&
                <p>{obj.text.length > 20 ? `${obj.text.slice(0, 20)}...`: obj.text}</p>
              }
              {
                obj.type === 'image' &&
                <img src={obj.src} alt="source" />
              }
            </div>
            <div className='option'>
              <span onClick={e=> handleDelete(index)}>
                <AiOutlineCloseCircle />
              </span>
              {/* <span>
                <AiOutlineUnlock />
              </span> */}
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default List